import { render, staticRenderFns } from "./giftCategoryDetail.vue?vue&type=template&id=03e9e1f0"
import script from "./giftCategoryDetail.vue?vue&type=script&lang=js"
export * from "./giftCategoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports